import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getTrainers, addTrainer, addTrainerToProd } from '../../actions';

class Trainer extends Component {

  initState = {
    checked: [],
    search: '',
    _id: '',
    email:'',
    details: {
      first_name: '',
      last_name: '',
      gender: '',
      profile_pic:'',
    },
    status: 'ACTIVE',
    type: 'TRAINER',
  }

  state = {
    ...this.initState,
    trainersAll: [],
    trainers: [],
    genders: ["MALE", 'FEMALE'],
    statuses: ['ACTIVE', 'DELETED'],
    types: ['TRAINER', 'TEST'],
  }

  componentWillMount = () => {
    this.props.getTrainers();
  }

  componentWillReceiveProps = (nextProps) => {
    if(nextProps.trainers) {
      this.setState({
        trainersAll: nextProps.trainers,
        trainers: nextProps.trainers
      })
    }

    if(nextProps.newTrainer) {
      this.props.getTrainers();
    }
  }

  handleChange = (evt) => {
    const value = evt.target.value;
    const name = evt.target.name;
    
    if(Object.keys(this.state.details).indexOf(name) !== -1 ){
      this.setState({
        ...this.state,
        details: { ...this.state.details, [name]: value },
      });
    } else {
      this.setState({
        ...this.state,
        [name]: value
      });
    }


    if(evt.target.name === 'search') {
      this.setState({
        trainers: this.state.trainersAll.filter(
          trainer => trainer.first_name.includes(value) || 
            trainer.last_name.includes(value) || trainer.email.includes(value)
            || trainer.gender.includes(value)
          )
      })
    }

  }

  submitForm = async (e) => {
    e.preventDefault();
    await this.props.addTrainer(this.state);

    this.setState({
      ...this.initState
    })
  }

  editTrainer = (trainer) => {
    if (this.state.checked.length >= 1) {
      this.setState({...this.initState})
    } else {
      this.setState({
        _id: trainer._id,
        email:trainer.normal_auth.email,
        details: {
          first_name:trainer.details.first_name,
          last_name: trainer.details.last_name,
          gender: trainer.details.gender,
          profile_pic:trainer.details.profile_pic,
        },
        status: trainer.status,
        type: trainer.type,
      })
    }
  }

  renderTrainers = () => (
    this.state.trainers.map((trainer, i) => {
      return <div key={i} className="inline-row inline-row-motivation" onClick={()=> this.editTrainer(trainer)}>
         <div className="column column-checkbox" style={{border: 'none'}}><input  className="checkbox" type="checkbox" name="workoutCheckbox" 
          checked={this.state.checked.indexOf(trainer._id) === -1 ? false : true }
          onChange={() => this.checkboxClick(trainer)}/></div>
        <div className="column-motivation hover">{trainer.details.first_name + " " + trainer.details.last_name}</div>
      </div>
    }) 
  )
  
  renderSelect = (options) => (
    options.map((lable, i) => {
      return <option key={i} value={lable}> {lable} </option>
    })
  )

  checkboxClick = (trainer) => {
    let index = this.state.checked.indexOf(trainer._id);
    if(index !== -1) {
      let checked = this.state.checked.filter(checkedW => checkedW !== trainer._id)
      
      this.setState({
        checked
      })
    } else {
      this.setState({
        checked: [...this.state.checked, trainer._id]
      })
    }
  }

  addToProduction = (e) => {
    e.preventDefault();
    let trainers = [];
    this.state.checked.forEach(id => {
      trainers.push(this.state.trainersAll.find(trainer => trainer._id === id));
    })

    this.setState({
      ...this.initState
    })
    if(trainers.length > 0) {
      this.props.addTrainerToProd(trainers);
    }
  }

  render() {
    return (
      <div>
        <div className="inline">
          <div className="motivation-div">
            <h2 className="headline">Trainers</h2>
            <div className="block">
            <input type="text" placeholder="Search"  name="search" value={this.state.search} onChange={this.handleChange} className="select-motivation search-input"/>
              {
                process.env.REACT_APP_ENVIRONMENT !== 'production'  ?
                  <button onClick={this.addToProduction} className="addButton final-btn final-btn-feedback">Add To Production</button>
                : null
              }
            </div>
            <div className="specific-feedbacks-head inline-row inline-row-motivation">
            <div className="column column-checkbox" style={{border: 'none'}} ></div>
              <div className="column-motivation column-head">Trainer Name</div>
            </div>
            <div className="specific-feedbacks">
              <div className="names">{this.renderTrainers()}</div>
            </div>
          </div>
            <form onSubmit={this.submitForm} className="add-form"> 
              <div style={{display: 'grid'}}>
              <input 
                    name="email"
                    type="text"
                    className="input input-motivation"
                    placeholder="Email"
                    value={this.state.email}
                    onChange={this.handleChange}
                />
                <input 
                    name="first_name"
                    type="text"
                    className="input input-motivation"
                    placeholder="First Name"
                    value={this.state.details.first_name}
                    onChange={this.handleChange}
                />
                <input 
                    name="last_name"
                    type="text"
                    className="input input-motivation"
                    placeholder="Last Name"
                    value={this.state.details.last_name}
                    onChange={this.handleChange}
                />
                <input 
                    name="profile_pic"
                    type="text"
                    className="input input-motivation"
                    placeholder="Profile Picture"
                    value={this.state.details.profile_pic}
                    onChange={this.handleChange}
                />
              <select className="select-motivation input-motivation"  name="gender" type="text" 
                placeholder="Gender" 
                value={this.state.details.gender} onChange={this.handleChange}>
                <option>Select</option>
                {this.renderSelect(this.state.genders)}
              </select>
              <select className="select-motivation input-motivation"  name="type" type="text" 
                placeholder="Type" 
                value={this.state.type} onChange={this.handleChange}>
                <option>Select</option>
                {this.renderSelect(this.state.types)}
              </select>
              <select className="select-motivation input-motivation"  name="status" type="text" 
                placeholder="State" 
                value={this.state.status} onChange={this.handleChange}>
                <option>Select</option>
                {this.renderSelect(this.state.statuses)}
              </select>
                </div>
              <button type="submit" className="savebtn" onClick={this.submitForm}>Save</button> 
            </form>
        </div>
      </div>
    );
  }
}

function mapStateToProps (state) {
  return {
    trainers: state.user.trainers,
    newTrainer: state.user.addTrainer,
    // addToProd: state.user.addTrainersToProd
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({ getTrainers, addTrainer, addTrainerToProd },dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Trainer);